import React, { useEffect, useState } from 'react'
import {
   Button,
   Form,
   Input,
   InputNumber,
   Space,
   Table,
   Typography,
   Card,
   Row,
   Col,
   Breadcrumb,
   message,
   Divider
} from 'antd'
import { PlusOutlined, DeleteOutlined, HomeOutlined } from '@ant-design/icons'
import Title from 'antd/lib/typography/Title'
import { useTranslation } from 'react-i18next'
import { formatCurrency } from 'src/helpers/functions'
import { useLoading } from 'src/common/components/LoadingContainer'
import { useStore } from 'src/hooks'

interface Item {
   id: string
   from: string
   to: string
   ghep1ghe: number
   baoxe5: number
   baoxe7: number
   khBaoxe5: number
   khBaoxe7: number
   hangNho: number
   hangTo: number
}

const EditableCell = ({ editing, dataIndex, title, inputType, record, children, ...restProps }: any) => {
   const inputNode =
      inputType === 'number' ? (
         <InputNumber
            min={0}
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
            style={{ width: '100%' }}
            step={1000}
            max={100000000}
         />
      ) : (
         <Input maxLength={254} />
      )

   return (
      <td {...restProps}>
         {editing ? (
            <Form.Item
               name={dataIndex}
               style={{ margin: 0 }}
               rules={[{ required: true, message: `Không được để trống` }]}
            >
               {inputNode}
            </Form.Item>
         ) : (
            children
         )}
      </td>
   )
}

const PriceScreen: React.FC = () => {
   const [form] = Form.useForm()
   const [editingKey, setEditingKey] = useState('')
   const [rows, setRows] = useState<Item[]>([])
   const UserStore = useStore('UserStore')
   const { t } = useTranslation()
   const { showLoading, hideLoading } = useLoading()
   const [addresses, setAddresses] = useState({
      hanoi: ['Ba Đình'],
      thanhhoa: ['Bỉm Sơn', 'Thanh Nga']
   })

   const isEditing = (record: Item) => record.id === editingKey

   const edit = (record: Item) => {
      form.setFieldsValue({ ...record })
      setEditingKey(record.id)
   }

   const cancel = () => {
      setEditingKey('')
   }

   useEffect(() => {
      getListData()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const getListData = async (currentPage?: number, param?: any) => {
      try {
         showLoading()
         // const offset = getPage(currentPage)
         const params = {
            // offset,
            ...param
         }
         console.log('param12123s', params, 'currentPage', currentPage)

         await UserStore.getPrices(params)
      } catch (error) {
         // console.log(error)
      } finally {
         hideLoading()
      }
   }

   const save = async (record: Item) => {
      try {
         const row = (await form.validateFields()) as Item

         const result = await UserStore.updatePrices(row, record.id as unknown as number)

         console.log('result', result)

         if (result) {
            const newData = [...UserStore.listPrices]
            const index = newData.findIndex((item) => record.id === item.id)

            if (index > -1) {
               newData.splice(index, 1, { ...result })
               // setRows(newData)
               UserStore.listPrices = newData
            }
            setEditingKey('')
            message.success('Cập nhật giá thành công')
         } else {
            message.error('Cập nhật giá thất bại, vui lòng thử lại sau')
            return
         }
      } catch (err) {
         console.log('Validate Failed:', err)
      }
   }

   const columns: any[] = [
      {
         title: 'Tuyến',
         dataIndex: 'id',
         key: 'id',
         render: (_: any, record: any) => `${record?.fromDistrict?.name} - ${record?.toDistrict?.name}`
      },
      {
         title: 'Ghép 1 ghế',
         dataIndex: 'priceGhep1',
         key: 'priceGhep1',
         editable: true,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true) + 'đ'}</span>
         }
      },
      {
         title: 'Bao xe 5',
         dataIndex: 'priceBaoXe5',
         key: 'priceBaoXe5',
         editable: true,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true) + 'đ'}</span>
         }
      },
      {
         title: 'Bao xe 7',
         dataIndex: 'priceBaoXe7',
         key: 'priceBaoXe7',
         editable: true,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true) + 'đ'}</span>
         }
      },
      {
         title: 'Khứ hồi bao xe 5',
         dataIndex: 'priceKhBaoXe5',
         key: 'priceKhBaoXe5',
         editable: true,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true) + 'đ'}</span>
         }
      },
      {
         title: 'Khứ hồi bao xe 7',
         dataIndex: 'priceKhBaoXe7',
         key: 'priceKhBaoXe7',
         editable: true,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true) + 'đ'}</span>
         }
      },
      {
         title: 'Gửi hàng nhỏ',
         dataIndex: 'priceHangNho',
         key: 'priceHangNho',
         editable: true,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true) + 'đ'}</span>
         }
      },
      {
         title: 'Gửi hàng to',
         dataIndex: 'priceHangTo',
         key: 'priceHangTo',
         editable: true,
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true) + 'đ'}</span>
         }
      },
      {
         title: t('actions'),
         key: 'action',
         align: 'center' as 'center',
         width: 120,
         fixed: 'right' as 'right',
         dataIndex: 'operation',
         render: (_: any, record: Item) => {
            const editable = isEditing(record)
            return editable ? (
               <span>
                  <Typography.Link onClick={() => save(record)} style={{ marginRight: 8 }}>
                     Lưu
                  </Typography.Link>
                  <Divider type="vertical" />
                  <Typography.Link onClick={cancel}>Hủy</Typography.Link>
               </span>
            ) : (
               <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                  Sửa
               </Typography.Link>
            )
         }
      }
   ]

   const mergedColumns = columns.map((col) => {
      if (!col.editable) {
         return col
      }
      return {
         ...col,
         onCell: (record: Item) => ({
            record,
            inputType: 'number',
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record)
         })
      }
   })

   return (
      <div style={{ padding: 16, background: '#fff' }}>
         <Row
            style={{ padding: '0 20px', marginBottom: 20 }}
            className="gx-justify-content-between gx-align-items-center"
         >
            <Col>
               <Title level={4}>{'Quản lý giá'}</Title>
               <Breadcrumb>
                  <Breadcrumb.Item href="/">
                     <HomeOutlined className="gx-link" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{'Admin'}</Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link">{'Quản lý giá'}</Breadcrumb.Item>
               </Breadcrumb>
            </Col>
         </Row>

         <Form form={form} component={false}>
            <Table
               components={{ body: { cell: EditableCell } }}
               dataSource={UserStore.listPrices || []}
               columns={mergedColumns}
               rowClassName="editable-row"
               rowKey="id"
               pagination={false}
               style={{ marginBottom: 20 }}
            />
         </Form>
      </div>
   )
}

export default PriceScreen
